import { MapfreButtonComponent } from '../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { CompanyService } from '@services/my-insurance/company.service';
import { filter } from 'rxjs/operators';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent],
  selector: 'app-auto-pay-promotion-banner',
  templateUrl: './auto-pay-promotion-banner.component.html',
})
export class AutoPayPromotionBannerComponent implements OnInit {
  isAcmic = false;
  showCompnay: string;
  isBillingRoute = false;
  isDetailsRoute = false;

  constructor(private acmicService: AcmicService,
    private companyService: CompanyService,
    private router: Router,
    private cdr: ChangeDetectorRef) {
    this.isAcmic = this.acmicService.isACMIC();
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.isBillingRoute = this.router.url.includes('billing');
      this.isDetailsRoute = this.router.url.includes('details');
      this.cdr.detectChanges();
    })
  }

  ngOnInit(): void {
    this.companyService.$currentCompany.subscribe((company) => {
      this.showCompnay = company;
    })
    this.isBillingRoute = this.router.url.includes('billing');
    this.isDetailsRoute = this.router.url.includes('details');
  }
}
